'use client';

import { addClassName } from '@hc-frontend/core-utils-format';
import type React from 'react';

import { useResizeObserver } from './reel.hooks';

/**
 * Component to create a reel.
 *
 * @param props - Props to configure this reel.
 * @returns
 */
export function Reel({
  children,
  className,
  ...props
}: React.ComponentProps<'div'>) {
  const ref = useResizeObserver();

  return (
    <div
      ref={ref}
      className={addClassName('hc-reel-layout', className)}
      {...props}
    >
      {children}
    </div>
  );
}
